import { Component, inject } from '@angular/core';
import { SidenavGroupItem } from '../../types/sidebar-group.models';
import { Roles } from '../../types/role.enum';
import { UserType } from '../../types/user-type.enum';
import { AuthService } from '../../libs/auth/auth.service';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environment-type';

@Component({
  standalone: false,
  selector: 'bt-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent {
  readonly authService = inject(AuthService);

  readonly isDevEnvironment =
    environment.type === EnvironmentType.develop || environment.type === EnvironmentType.develop_frontend;

  get userType(): string {
    return this.authService.userLoggedValue?.UserType ?? '';
  }

  allSidenavGroups: Array<SidenavGroupItem> = [
    {
      groupUrlPart: 'company',
      userType: UserType.COMPANY,
      groupItems: [
        {
          menuLabel: 'Dashboard',
          menuRoute: 'dashboard',
          icon: 'fa-solid fa-chart-line',
          requiredRoles: [Roles.COMPANY_ADMIN, Roles.COMPANY_USER],
          childRoutes: []
        },
        {
          menuLabel: 'Manage orders',
          menuRoute: 'order-list',
          icon: 'fa-solid fa-dolly',
          requiredRoles: [Roles.COMPANY_ADMIN, Roles.COMPANY_USER, Roles.PHOTOGRAPHER],
          childRoutes: ['order-view', 'order-info']
        },
        {
          menuLabel: 'Manage media',
          menuRoute: 'style-list',
          icon: 'fa-solid fa-images',
          requiredRoles: [Roles.COMPANY_ADMIN, Roles.COMPANY_USER],
          childRoutes: ['style-info']
        },

        {
          menuLabel: 'Photographers',
          menuRoute: 'photographer-list',
          icon: 'fa-solid fa-user-group',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: ['photographer-detail']
        },

        {
          menuLabel: 'Order templates',
          menuRoute: 'template-list',
          icon: 'fa-regular fa-object-group',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: ['template-detail']
        },

        {
          menuLabel: 'Third parties applications',
          menuRoute: 'third-parties-applications',
          icon: 'fa fa-arrow-right-from-bracket',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: ['pim', 'legacy']
        },

        {
          menuLabel: 'Insights',
          menuRoute: 'insight-style-price',
          icon: 'fa-regular  fa-chart-bar',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: ['insight-style-price']
        },
        {
          menuLabel: 'Media sharing',
          menuRoute: 'media-share-link-list',
          icon: 'fa-solid fa-share-from-square',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: ['media-share-link-detail']
        },
        {
          menuLabel: 'Shot types',
          menuRoute: 'shot-types-list',
          icon: 'fa-solid fa-camera',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: []
        },
        {
          menuLabel: 'User role settings',
          menuRoute: 'user-role-settings',
          icon: 'fa-solid fa-user-shield',
          requiredRoles: [Roles.COMPANY_ADMIN],
          childRoutes: []
        }
        /*{
					menuLabel: 'Configure costs',
					menuRoute: 'cost-templates-management-list',
					icon: 'fa-solid fa-euro-sign',
					requiredRoles: [Roles.COMPANY_ADMIN],
					childRoutes: []
				}*/
      ]
    },
    {
      groupUrlPart: 'photographer',
      userType: UserType.PHOTOGRAPHER,
      groupItems: [
        {
          menuLabel: 'Manage orders',
          menuRoute: 'order-list',
          icon: 'fa-solid fa-dolly',
          requiredRoles: [Roles.COMPANY_ADMIN, Roles.COMPANY_USER, Roles.PHOTOGRAPHER],
          childRoutes: ['order-view', 'order-info']
        }
      ]
    }
  ];
}
